import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maxCharsDisplay',
  pure: true,
  standalone: false,
})
export class MaxCharsDisplayPipe implements PipeTransform {
  transform(value: string, length: number = 16): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (value.length < length) {
      return value;
    }
    return value.slice(0, length+1).trim() + '..';
  }
}
